import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TestsPage } from '@/features/quality/tests-page';

const searchSchema = z.object({
  test: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/quality/tests')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <TestsPage projectId={projectId} testId={search.test} />;
}
